import {get} from './base.service'
import utils from 'utils'
export default {
    // 查询个人健康特征
    getCharacter(params) {
        return get('/app/health/getCharacter', {params: params}).then(res => {
            if (res.resultCode === '1') {
                return res.data;
            } else {
                utils.alert(res.resultMsg)
            }
        });
    },
    // 获取用户的就诊记录列表
    getVisit(params) {
        return get('/app/health/getVisit', {params: params}).then(res => {
            if (res.resultCode === '1') {
                return res.data;
            } else {
                utils.alert(res.resultMsg)
            }
        });
    },
    // 获取用户的用药履历列表
    getMedHistory(params) {
        return get('/app/health/getMedHistory', {params: params}).then(res => {
            if (res.resultCode === '1') {
                return res.data;
            } else {
                utils.alert(res.resultMsg)
            }
        });
    },
    // 获取用户的体检信息列表
    getPhysicalExam(params) {
        return get('/app/health/getPhysicalExam', {params: params}).then(res => {
            if (res.resultCode === '1') {
                return res.data;
            } else {
                utils.alert(res.resultMsg)
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/service/record.service.js